export type FreeroamHintAction = () => void | Promise<void>

export type FreeroamHintActions = {
    leaveFreeroam: FreeroamHintAction
    toggleHints: FreeroamHintAction
    toggleDriftHud: FreeroamHintAction
}

export type FreeroamHintConfigItem = {
    id: string
    translationKey: string
    buttons: string[]
    action: FreeroamHintAction
}

export const createFreeroamHintsConfig = (
    actions: FreeroamHintActions
): FreeroamHintConfigItem[] => [
        {
            id: 'leave',
            translationKey: 'freeroam_hint_leave',
            buttons: ['F3'],
            action: actions.leaveFreeroam,
        },
        {
            id: 'open-main-menu',
            translationKey: 'freeroam_hint_open_main_menu',
            buttons: ['M'],
            action: () => { },
        },
        {
            id: 'toggle-drift-hud',
            translationKey: 'freeroam_hint_toggle_drift_hud',
            buttons: ['4'],
            action: actions.toggleDriftHud,
        },
        {
            id: 'toggle-hints',
            translationKey: 'freeroam_hint_hide_menu',
            buttons: ['Shift', 'Z'],
            action: actions.toggleHints,
        },
    ]